import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrCreateTermPayload } from 'api/actions/hr-create-term/hr-create-term-payload';
import { HrCreateTermPathParameters } from 'api/actions/hr-create-term/hr-create-term-path-parameters';
import { HrCreateTermResponse } from 'api/actions/hr-create-term/hr-create-term-response';

type HrCreateTermQueryParameters = Record<string, any>;

/**
 * The path of the HrCreateTerm action.
 */
export const hrCreateTermActionPath = new SweetPath<keyof HrCreateTermPathParameters>(
  '/api/hr/people/{personId}/terms',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrCreateTerm actions.
 */
export default function createHrCreateTermAction(axios: AxiosInstance) {
  return function hrCreateTermAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrCreateTermPathParameters;
    query?: HrCreateTermQueryParameters;
    payload: HrCreateTermPayload;
  }) {
    const path = hrCreateTermActionPath.insert(parameters);

    return axios.request<HrCreateTermResponse, HrCreateTermResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
